import equal from 'fast-deep-equal';
import { isNil, pick } from 'lodash-es';
import { memo } from 'react';
import * as preloaded from 'resources/svg/preloaded';

const pickProps = (props: $TSFixMe) => pick(props, ['name', 'folder', 'path', 'fallBackImg', 'width', 'height']);

const Icon = memo(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type '{ children... Remove this comment to see the full error message
  ({ name, folder = 'icons', path = undefined, fallBackImg = `/assets/svg/flags/empty.svg`, width = '30', height = '30' }) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!isNil(preloaded[name])) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return preloaded[name];
    }

    if (!isNil(path)) {
      const defaultSrc = (e: $TSFixMe) => {
        e.target.src = `${process.env.PUBLIC_URL}${fallBackImg}`;
      };

      return <img loading="lazy" alt={name} src={`${process.env.PUBLIC_URL}${path}`} width={width} height={height} onError={(e) => defaultSrc(e)} />;
    }

    console.error('Use named export for SVG', { name, folder, preloaded });

    return null;
  },
  (prev, next) => equal(pickProps(prev), pickProps(next)),
);

export default Icon;
